import { Record } from 'immutable';
import { schema } from 'normalizr';

export const UserOption = new Record({
  id: undefined,
  notifications_via_web: undefined,
  notifications_via_email: undefined,
  notifications_via_app: undefined,
  notifications_via_sms: undefined,
  user: undefined,
  receive_charting_reminder_emails: undefined,
  receive_alarm_report_emails: undefined,
  receive_report_emails: undefined,
  critical_system_emails: undefined,
  info_system_emails: undefined,
  agreement_signed_time: undefined,
  autodisabled_emails_timestamp: undefined,
  time_zone: undefined,
  alarm_report_email_hour: undefined,
  locale: undefined,
  date_format: undefined,
  time_format: undefined,
  measurement_system: undefined,
  start_of_week: undefined,
  number_format: undefined,
});

export const userOptionSchema = new schema.Entity('userOptions');

// for reading in nested models, object with { field: schema }
// userOptionSchema.define({  });
